import { render, staticRenderFns } from "./seconds-user.vue?vue&type=template&id=820b826a&"
import script from "./seconds-user.vue?vue&type=script&lang=js&"
export * from "./seconds-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports